import Page from 'components/layout/Page';
import Cta from 'components/marketingSite/shared/Cta';
import TeamCard from 'components/marketingSite/team/TeamCard';
import TeamWhy from 'components/marketingSite/team/TeamWhy';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { WebTeam } from 'interfaces/ui/web/team';
import { useRouter } from 'next/dist/client/router';
import { getTranslatedText } from 'services/multilingual.service';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledTeam, StyledTeamCards } from './TeamComponent.styled';

export type TeamComponentProps = {
  team: WebTeam[];
};

const TeamComponent: React.FC<TeamComponentProps> = ({ team }) => {
  const { locale } = useRouter();
  const { t } = useI18n('web');

  return (
    <Page hasScrollTop>
      <StyledTeam>
        <Heading1 editorial>{t('team.hero.title')}</Heading1>
        <StyledTeamCards>
          {team?.map((item) => {
            return (
              <TeamCard
                key={item.name}
                name={item.name}
                url={
                  item.url
                    ? `${getAppUrl(APP_URLS.blog, locale)}/${item.url}`
                    : undefined
                }
                img={item.img}
                desc={getTranslatedText(item.desc, locale)}
                twitter={item.twitter}
                linkedin={item.linkedin}
              />
            );
          })}
        </StyledTeamCards>
        <TeamWhy />
        <Cta />
      </StyledTeam>
    </Page>
  );
};

export default TeamComponent;
